import fetcher from "lib/fetcher";
import useSWRImmutable from "swr/immutable";

const key = "/api/v2/countries";

export type Country = {
  id: number;
  zone_id: number;
  chinaarea: string;
  country: string;
  country_code: string;
  description: string;
  isoNumeric: string;
  ispAlpha3: string;
  state_code: string;
  timezone: string;
};

export default function useCountries() {
  return useSWRImmutable<Country[]>(key, (key) => {
    return fetcher({ url: key }).then((res) => {
      return res["countries"];
    });
  });
}
